<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Reading This Volume">
<p class="fm_h1" id="sec4"><span class="right_1" epub:type="pagebreak" id="page_xix" title="xix"><a href="#/text/9780253063526_Contents#rsec4">READING THIS VOLUME</a></span></p>
<p class="noindent_para"><span class="smallcaps">NUMBERS IN THE TEXT</span>, <span class="smallcaps">AS</span> given below, and given in parentheses [e.g., (3)], at the beginning of thematic segments refer to the originator of the lore, as told to Seán Mac Giollarnáth. This reference methodology was used by Seán Mac Giollarnáth in other publications and is preserved here. Meet the Storytellers provides further information on the individuals below.</p>
<div class="number">
<p class="num">1.<span class="spacen">Micheál Mac Donnchadha, Roisín na Mainiach, Carna</span></p>
<p class="num">2.<span class="spacen">Pádraic Mac Donnchadha (Liam), An Coillín, Carna</span></p>
<p class="num">3.<span class="spacen">Pádraic Mac Con Iomaire, An Coillín, Carna</span></p>
<p class="num">4.<span class="spacen">Seosamh Mac Donnchadha, An Aird Thiar, Carna</span></p>
<p class="num">5.<span class="spacen">Parthalán Ó Guairim, Leitreach Ard, Carna</span></p>
<p class="num">6.<span class="spacen">Séamas Ó Conghaile, An Aird, Carna</span></p>
<p class="num">7.<span class="spacen">Pádraic Ó Clochartaigh, Baile na Cille, Gorumna Island</span></p>
<p class="num">8.<span class="spacen">Parthalán Mac Donnchadha, An Aird Thiar, Carna</span></p>
<p class="num">9.<span class="spacen">Seán Ó Briain, Loch Conaortha, Cill Chiaráin</span></p>
<p class="num1">10.<span class="spacen">Tomás Mac Con Iomaire, An Coillín, Carna</span></p>
<p class="num1">11.<span class="spacen">Seosamh Ó Mongáin, TD, Carna</span></p>
<p class="num1">12.<span class="spacen">Seán Mac Con Rí, Leitir Daimh, Roundstone</span></p>
<p class="num1">13.<span class="spacen">Máire Ní Dhomhnaill, Caladh an Chnoic, Carna</span></p>
<p class="num1"><span class="right_1" epub:type="pagebreak" id="page_xx" title="xx">14.<span class="spacen">Tomás Ó Máille, Coill Mhíolcon</span></span></p>
<p class="num1">15.<span class="spacen">Liam Bairéad, An Coillín, Carna</span></p>
<p class="num1">16.<span class="spacen">Mártan Ó Málóid, County Councillor, Carna</span></p>
<p class="num1">17.<span class="spacen">Pádraic Mac Donnchadha (Éamoinn), An Aird, Carna</span></p>
<p class="num1">18.<span class="spacen">Isaac Ó Conaire, Seantalamh, Galway</span></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253063526_Frontmatter05.vue?f1048776